
export const ADD_VIEW_ERA ="ADD_VIEW_ERA";
export function addViewEra(updates){
    return {
      type: ADD_VIEW_ERA,
      payload: updates
    }
  }


// WEBPACK FOOTER //
// ./src/app/era/actions.js